interface CodeBlockProps {
  code: string;
  title?: string;
}

export function CodeBlock({ code, title }: CodeBlockProps) {
  return (
    <div className="mb-4">
      {title ? (
        <p
          className="text-xs uppercase tracking-wide mb-2 font-medium"
          style={{ color: 'var(--clique-fg-tertiary)' }}
        >
          {title}
        </p>
      ) : null}
      <pre
        className="overflow-x-auto p-4 text-xs leading-relaxed"
        style={{
          backgroundColor: 'var(--clique-bg-muted)',
          color: 'var(--clique-fg)',
          border: '1px solid var(--clique-border)',
          borderRadius: 'var(--clique-radius)',
        }}
      >
        <code>{code.trim()}</code>
      </pre>
    </div>
  );
}
